import { RequestFieldFilterType, SearchRequest } from '@interfaces/models';
import { PaginationState, SortingState } from '@ui/components';

export function getTableFilters<Filters extends Record<string, string[] | string>>(
  searchLength: number,
  searchPhrase?: string,
  filters?: Filters,
) {
  const search = searchPhrase && searchPhrase?.length >= searchLength ? searchPhrase : undefined;
  const fieldsArray = Object.entries(filters ?? {})
    .flatMap(([field, values]) => {
      if (Array.isArray(values)) {
        return values.map((value) => ({ field: field as RequestFieldFilterType, value }));
      }
      return [{ field: field as RequestFieldFilterType, value: values }];
    })
    .filter(({ value }) => !!value.length);

  const fields = fieldsArray.length ? fieldsArray : undefined;

  return search || fields
    ? {
        search,
        fields,
      }
    : undefined;
}

export const getTablePagination = (pagination: Partial<PaginationState>) => {
  return {
    pageIndex: pagination.pageIndex ?? 0,
    pageSize: pagination.pageSize ?? 5,
  };
};

export const getTableSort = (sorting: Partial<SortingState>) => {
  const [firstSorting] = sorting ?? [];
  if (!firstSorting || !firstSorting.id) return undefined;
  return {
    direction: firstSorting.desc ? 'DESC' : 'ASC',
    columnName: firstSorting.id ?? '',
  };
};

export function getTableRequest<Filters extends Record<string, string[]>>({
  searchLength = 2,
  pagination,
  sorting,
  filters,
  search,
}: {
  pagination?: Partial<PaginationState>;
  sorting?: SortingState;
  searchLength?: number;
  filters?: Filters;
  search?: string;
}): SearchRequest {
  return {
    pagination: getTablePagination(pagination ?? {}),
    sort: sorting ? getTableSort(sorting) : undefined,
    filters: getTableFilters(searchLength, search, filters),
  };
}
